import texts from "./texts.js";

const Langnames = {
    en: "English",
    uk: "Українська",
};

// https://www.w3schools.com/tags/ref_language_codes.asp
const Lang2HTML = {
    en: "en",
    uk: "uk",
};

const translation = {};

for (const key in texts) {
    for (const locale in texts[key]) {
        translation[locale] = translation[locale] ?? { translation: {} };
        translation[locale].translation = translation[locale].translation ?? {};
        translation[locale].translation[key] = texts[key][locale];
    }
}

export default translation;

export { Lang2HTML, Langnames };
